import { render, staticRenderFns } from "./WhatsNew.vue?vue&type=template&id=daa26f1a&scoped=true"
import script from "./WhatsNew.vue?vue&type=script&lang=js"
export * from "./WhatsNew.vue?vue&type=script&lang=js"
import style0 from "./WhatsNew.vue?vue&type=style&index=0&id=daa26f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa26f1a",
  null
  
)

export default component.exports